import VacationCommonModal from '@pages/vacation/components/VacationCommonModal';
import useDocumentPreview from '@features/document-write/hooks/useDocumentPreview';
import PrintableVacationDetail from '@pages/admin/vacation/components/PrintableVacationDetail';
import Button from '@shared/components/atoms/Button';
import { useGetVacationFile } from '@features/vacation/hooks';
import searchMdIcon from '@shared/assets/images/search-md_icon.svg';

import styles from '@pages/admin/vacation/components/VacationAdminDetailModal/VacationAdminDetailModal.module.scss';

export default function VacationAdminDetailModal({
  vacation,
  vacationData,
  vacationStatus,
  allList,
  isOpen,
  onClose,

  isLoading,
  onDelete,
  onAlert,
}) {
  const state = vacationData?.state;
  const isDeletable = state != null && state !== 5 && state !== 7;
  function handleDelete() {
    if (!vacation?.idx) return;
    onDelete(vacation.idx);
  }

  const { mutate: downloadFile } = useGetVacationFile({
    onError: (err) => {
      onAlert?.(
        err?.message || '보안 정책에 따라 첨부파일 다운로드는 허용된 IP 환경에서만 가능합니다.',
      );
    },
  });

  function handleFileClick(file) {
    downloadFile({
      fileIdx: file.idx,
      fileName: file.name,
      fileURL: file.url || file.fileURL,
    });
  }
  // TODO 미리보기
  const { isPreviewMode, printContentRef, handlePreview, handleClosePreview, handlePrint } =
    useDocumentPreview();
  if (isPreviewMode) {
    return (
      <>
        <div className={styles.previewOverlay}>
          {/* 실제 출력 대상 */}
          <PrintableVacationDetail
            ref={printContentRef}
            vacationData={vacationData}
            remainVacationData={remainVacationData}
            handlePrint={handlePrint}
            handleClosePreview={handleClosePreview}
          />
        </div>
      </>
    );
  }
  return (
    <>
      {/* ================= 관리자 상세 모달 ================= */}
      <VacationCommonModal
        isOpen={isOpen}
        onClose={onClose}
        vacation={vacation}
        vacationData={vacationData}
        vacationStatus={vacationStatus}
        allList={allList}
        onFileClick={handleFileClick}
        footer={
          <>
            {isDeletable && (
              <Button variant="danger" className={styles.btn} onClick={handleDelete}>
                삭제
              </Button>
            )}
            <Button onClick={handlePreview} className={styles.previewButton}>
              <img src={searchMdIcon} alt="" className={styles.previewIcon} />
              <span>미리보기</span>
            </Button>
          </>
        }
      />
    </>
  );
}
